import { InlineText } from '@hg/stylizator/typography'
import parse, { attributesToProps, domToReact, HTMLReactParserOptions, Element } from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

interface InnerBlock extends IWPGBlock {
  innerContent?: (string | null)[]
}

interface Props {
  innerBlocks: InnerBlock[]
}

const options: HTMLReactParserOptions = {
  trim: true,
  replace: (domNode) => {
    if (domNode instanceof Element && domNode.attribs) {
      const props = attributesToProps(domNode.attribs)
      const children = domToReact(domNode.children, options)

      if (domNode.name === 'li') {
        return (
          <InlineText type="body" useCompact>
            <span>
              <li {...props}>{children}</li>
            </span>
          </InlineText>
        )
      }
    }

    return domNode
  },
}

const WPGListBlock: React.FC<IWPGBlock & Props> = (props) => {
  const isOrdered = !Array.isArray(props.attrs) && props.attrs.ordered
  const content = insertInnerBlocks(props)
  const parsedContent = parse(content, options)

  const Component = isOrdered ? 'ol' : 'ul'

  return <Component>{parsedContent}</Component>
}

const insertInnerBlocks = ({ innerBlocks }: Props): string =>
  innerBlocks.reduce((result, block) => {
    if (block.innerBlocks.length === 0) {
      const content = block?.innerContent?.filter((it) => it !== null).join('') ?? ''
      return result + content
    } else {
      const content = block?.innerContent?.filter((it) => it !== null) ?? ''
      const firstPart = content?.[0] ?? ''
      const lastPart = content?.[content.length - 1] ?? ''
      const innerBlockContents = insertInnerBlocks({ innerBlocks: block.innerBlocks })
      return result + `${firstPart}${innerBlockContents}${lastPart}`
    }
  }, '')

export default WPGListBlock
